import type { PayloadAction } from '@reduxjs/toolkit';
import type { IProcosState } from '../../../../types';

export const workItemReducers = {
  setEditMode(state: IProcosState, action: PayloadAction<any>): void {
    state.isEditMode = action.payload.isEdit;
  },
  setActiveWorkItem(state: IProcosState, action: PayloadAction<any>): void {
    state.activeWorkItem = action.payload;
  },
  setNewWorkItem(state: IProcosState, action: PayloadAction<any>): void {
    state.newWorkItem = action.payload;
  },
};
